import type React from "react";
import { useInView } from "react-intersection-observer";

// HOC for Spring Animation
const AnimatePresence = ({
  children,
  className,
  name,
}: {
  children: React.ReactNode;
  name: string;
  className?: string;
}) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  console.log(inView, name);
  return (
    <div
      ref={ref}
      className={className}
      style={{
        maxWidth: "100%",
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(50px)",
        animation: inView
          ? "springRise 1.2s cubic-bezier(0.175, 0.885, 0.32, 1.0) forwards"
          : "none",
      }}
    >
      {children}
    </div>
  );
};

export default AnimatePresence;
